import { render, staticRenderFns } from "./UserModulesEdit.vue?vue&type=template&id=1e033b8e&"
import script from "./UserModulesEdit.vue?vue&type=script&lang=ts&"
export * from "./UserModulesEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports